/* Video reviews. Each card shows a poster until it is clicked — five vertical
   clips autoplaying at once would cost more bandwidth than the whole page.
   Starting one clip pauses whichever other clip was running. */
(function () {
  function init(root) {
    if (root.dataset.videoReviewsReady === 'true') return;
    root.dataset.videoReviewsReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-video-card]'));

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      card.addEventListener('click', function () {
        if (!video.paused) {
          video.pause();
          card.classList.remove('is-playing');
          return;
        }

        cards.forEach(function (other) {
          if (other === card) return;
          var otherVideo = other.querySelector('video');
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            other.classList.remove('is-playing');
          }
        });

        // Browsers reject play() until the gesture is trusted; ignoring the
        // rejection leaves the poster in place rather than throwing.
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
        card.classList.add('is-playing');
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
      });
    });
  }

  document.querySelectorAll('[data-video-reviews]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-video-reviews]').forEach(init);
  });
})();
